export default "__VITE_ASSET__BPi9PK9d__"